<template>
  <ActionDropdown :actions="actions" :cssClass="cssClass" />
</template>
<script>
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
export default {
  components: {
    ActionDropdown,
  },
  props: {
    cssClass: String,
  },
  data() {
    return {
      formData: {},
    };
  },
  emits: [
    'renewal',
    'expire'
  ],
  computed: {
    actions() {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
      return [
        {
          label: this.i18n('Renewal'),
          fn: () => {
            this.$emit('renewal', this.user);            
          },          
        },
        {
          label: this.i18n('Expire'),
          fn: () => {
          this.$emit('expire', this.user);          
          },  
        },    
        
      ];
    },
  },
  methods: {
  },
};
</script>
